import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface DollarIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function DollarIcon({ color = RoutalPalette.primary80, style = {} }: DollarIconProps) {
  return (
    <SvgIcon width="9" height="15" viewBox="0 0 9 15" style={{ ...style }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3 1.35981C5.3 0.930254 4.94184 0.582031 4.5 0.582031C4.05816 0.582031 3.7 0.930254 3.7 1.35981V2.13759C1.93268 2.13759 0.5 3.53047 0.5 5.2487C0.5 6.96693 1.93268 8.35981 3.7 8.35981V11.4709C3.0046 11.4709 2.41088 11.0392 2.19084 10.4339C2.0436 10.029 1.58656 9.81666 1.16996 9.95982C0.7534 10.103 0.53504 10.5473 0.68228 10.9523C1.1212 12.1596 2.30544 13.0265 3.7 13.0265V13.8043C3.7 14.2338 4.05816 14.582 4.5 14.582C4.94184 14.582 5.3 14.2338 5.3 13.8043V13.0265C7.06732 13.0265 8.5 11.6336 8.5 9.91537C8.5 8.19714 7.06732 6.80425 5.3 6.80425V3.69314C5.9954 3.69314 6.58912 4.12489 6.80916 4.73011C6.9564 5.1351 7.41344 5.3474 7.83004 5.20425C8.2466 5.0611 8.46496 4.61671 8.31772 4.21173C7.8788 3.00442 6.69456 2.13759 5.3 2.13759V1.35981ZM3.7 3.69314C2.81636 3.69314 2.1 4.3896 2.1 5.2487C2.1 6.10779 2.81636 6.80425 3.7 6.80425V3.69314ZM5.3 8.35981V11.4709C6.18364 11.4709 6.9 10.7745 6.9 9.91537C6.9 9.05627 6.18364 8.35981 5.3 8.35981Z"
        fill={color}
      />
    </SvgIcon>
  );
}
